'use client';

import HeadlineField from '@/components/customFields/HeadlineField';
import { HeadlineTag } from '@/components/customFields/types';
import { getFormattedDMYDate } from '@/helper/dates';
import classes from '@/storyblok/orderStatus/OrderStatus.module.scss';
import type { PartialOrderStatusStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react';
import { useTranslation } from 'react-i18next';

import OrderStatusStep from './OrderStatusStep';

const OrderStatus: React.FC<{ blok: PartialOrderStatusStoryblok }> = ({ blok }) => {
  const { t } = useTranslation();
  const formattedDate = getFormattedDMYDate(String(new Date()));

  return (
    <div className={classes.orderStatus} {...storyblokEditable(blok)}>
      {blok.headline && (
        <HeadlineField className={classes.headline} tag={HeadlineTag.H3} style={HeadlineTag.H6}>
          {blok.headline}
        </HeadlineField>
      )}

      <div>
        <OrderStatusStep heading={t('order.orderStatus.orderedOn', { date: formattedDate })} status="success" />
        {blok.orderstatus?.map((orderStatus, index) => {
          return (
            <OrderStatusStep
              text={orderStatus.text}
              heading={orderStatus.heading}
              status={orderStatus.status}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
};
export default OrderStatus;
